export const printLabels = (labels) => {
  if (!labels || labels?.length === 0) return false;

  for (let label of labels) {
    const link = document.createElement("a");
    link.href = "data:application/pdf;base64," + label?.content;
    link.download = "etiqueta.pdf";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  return true;
};
